import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { Alert, CoreMsgTypes } from '@tassat/fred-definitions';

type AlertsState = Alert[];

const initialState: AlertsState = [];

const alertRecordAction = createAction<Alert>(CoreMsgTypes.Alert);
const setAlertsRecordAction = createAction<Alert[]>('SET_ALERTS');

const alertsSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                setAlertsRecordAction,
                (_state, action) => action.payload
            )
            .addCase(
                alertRecordAction,
                (state, action) => {
                    state.unshift(action.payload);
                }
            )
            .addDefaultCase(state => state);
    }
});

export default alertsSlice.reducer;